import { useContext, useEffect, useRef, useState } from "react";
import Uploadimg from "../../assets/img/uploaddocoment.png";
import useTranslator from "../../hooks/useTranslator";
import TenantContext from "../../context/tenant/TenantContext";
import constants from "../../Utils/constants";
import docsData from "../../Utils/docsData";
import {
  getDocumentsFromEmploymentType,
  haveValue,
  toast,
} from "../../helper/common";
import DocItem from "../../components/Onboarding/DocItem";
import moreInfoimg from "../../assets/img/moreInfoimg.svg";
import SkorDefaultLoader from "../../assets/img/skorDefaultLoader.gif";
import ApprovedModal from "./approvedModal";
import DocumentAnalysisLoadingPopup from "../../components/Onboarding/DocumentAnalysisLoading";
import { docsMap } from "../../Utils/skorLiteDocumentMap";
import { useNavigate } from "react-router-dom";
import Cancelimg from "../../assets/img/cancel-01.svg";
import { useMediaQuery } from "react-responsive";
import PermissoWidget from "./PermisssionWidget";
import * as pdfjsLib from "pdfjs-dist/webpack";
import { trackClarityEvent } from "../../Utils/clarityReady";
import AuthContext from "../../context/auth/AuthContext";
import ButtonActionTooltip from "../../components/ErrorModal/ButtonActionTooltip";
import DisableZoom from "../../helper/disableZoom";

const RequiredDocumentsModal = ({
  user,
  formHandler,
  requiresSubcategory,
  updateUserProfile,
  isGuarantor,
  isFirstTime = false,
  guarantor_a_id,
  reqFor,
  onClose,
  redirectUrl,
  setDocAnalysisLoading,
  isOpen,
  reloadTrigger,
  needWaitingJobForClave,
  isEditMode,
  fetchFileDataParent,
}) => {
  const fileInputRef = useRef(null);
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const {
    initiateBankFlip,
    fetchTenantDocs,
    uploadFileData,
    fetchWaitingData,
    detectDocument,
    skipDuplicateDocument,
  } = useContext(TenantContext);
  const { loadUserTenant } = useContext(AuthContext);
  const isMobile = useMediaQuery({ maxWidth: 667 });
  const [docUploadLoading, setDocUploadLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showApprovalPopup, setShowApprovalPopup] = useState(false);
  const [availableClaveDocs, setAvailableClaveDocs] = useState([]);
  const [tenantDocsData, setTenantDocsData] = useState([]);
  const [documentLoading, setDocumentLoading] = useState(true);
  const [waitingJobLoading, setWaitingJobLoading] = useState(false);
  const queryParameters = new URLSearchParams(window.location.search);
  const waitingId = queryParameters.get("waiting");
  const [waitingJobId, setWaitingJobId] = useState(null);
  // got from clave as a redirect url
  const welcome = queryParameters.get("welcome");
  const [showWelcomePopup, setShowWelcomePopup] = useState(false);
  const [claveWidgetUrl, setClaveWidgetUrl] = useState(null);
  const [invalidFiles, setInvalidFiles] = useState([]);

  useEffect(() => {
    setShowWelcomePopup(welcome === "true");
  }, [queryParameters]);

  // ✅ File Validation Helper
  const validateFiles = async (newFiles) => {
    const validatedFiles = [];
    const invalidFilesTemp = [];

    for (let file of newFiles) {
      // 🔹 File type check
      if (
        !["application/pdf", "image/jpeg", "image/png", "image/jpg"].includes(
          file.type,
        )
      ) {
        invalidFilesTemp.push({
          name: file.name,
          reason: _t("fileTypeNotAllowed", "File type not allowed"),
        });
        continue;
      }

      // 🔹 File size check (8 MB)
      if (file.size > 8 * 1024 * 1024) {
        invalidFilesTemp.push({
          name: file.name,
          reason: _t(
            "fileUploadedExceedsTwoPointFiveMbFileLimit",
            "File exceeds 4MB limit",
          ),
        });
        continue;
      }

      try {
        if (file.type === "application/pdf") {
          const arrayBuffer = await file.arrayBuffer();
          await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
        } else {
          // 🔹 Validate image
          await new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve();
            img.onerror = () => reject(new Error("Corrupted image"));
            img.src = URL.createObjectURL(file);
          });
        }

        validatedFiles.push(file);
      } catch (err) {
        let reason = _t(
          "isCorruptedOrUnreadableFile",
          "is corrupted or unreadable",
        );
        if (err?.message?.toLowerCase()?.includes("password")) {
          reason = _t("isPasswordProtectedPDF", "is password protected");
        }

        invalidFilesTemp.push({ name: file.name, reason });
      }
    }

    // ✅ Append invalid files instead of replacing
    if (invalidFilesTemp.length > 0) {
      setInvalidFiles((prev) => [...prev, ...invalidFilesTemp]);
    }

    // ✅ Return validated files so you can append them in parent logic
    return validatedFiles;
  };

  const startWaitingJobInterval = (waitingId) => {
    if (!haveValue(waitingId)) return;

    setWaitingJobLoading(true);

    const temp_interval = setInterval(() => {
      fetchWaitingData(waitingId)
        .then((res) => {
          if (res.status === constants.COMPLETED) {
            clearInterval(temp_interval);

            // Doing this for tenant for approval popup to get latest clave done value.
            if (!isGuarantor) {
              loadUserTenant("tenant");
            }
            fetchFileData(res?.tenant_id);
            fetchFileDataParent?.();
            setWaitingJobLoading(false);

            // Remove 'waiting' param from URL
            const params = new URLSearchParams(window.location.search);
            params.delete("waiting");
            const newUrl =
              window.location.pathname +
              (params.toString() ? `?${params.toString()}` : "");
            window.history.replaceState({}, "", newUrl);
          }
        })
        .catch((err) => {
          console.error("❌ Waiting job error:", err);
          setWaitingJobLoading(false);
          clearInterval(temp_interval);
        });
    }, 1000);

    return temp_interval;
  };

  useEffect(() => {
    if (haveValue(waitingId)) {
      const intervalId = startWaitingJobInterval(waitingId);

      return () => clearInterval(intervalId);
    }
  }, []);

  useEffect(() => {
    fetchFileData();
  }, [reloadTrigger, isOpen]);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleUploadFiles = async (
    fileType = "uploaded-from-onboarding",
    fileFrom,
  ) => {
    if (docFound.size === 0 && selectedFiles.length === 0) {
      toast.error(
        _t("pleaseUploadDocumentsToContinue", "Text used in onboarding flow"),
      );
      return;
    }
    try {
      if (reqFor === "updateDoc") {
        if (selectedFiles.length > 0) {
          setDocAnalysisLoading(true);
        } else {
          onClose();
        }
      } else {
        setDocUploadLoading(true);
      }
      await skipDuplicateDocument();
      const formData = new FormData();

      for (let file of selectedFiles) {
        formData.append("tenantDocs", file);
      }

      formData.append("fileType", fileType);
      if (fileFrom) formData.append("fileFrom", fileFrom);

      if (selectedFiles.length > 0) {
        await uploadFileData(formData, false, user?._id, isGuarantor);
        setSelectedFiles([]);
        if (reqFor === "updateDoc") {
          setDocAnalysisLoading(false);
          onClose();
          fetchFileDataParent?.();
          // If we are waiting for documents to upload
        } else {
          // removing clavedone field
          const url = new URL(window.location);
          url.searchParams.delete("claveDone");
          window.history.replaceState(
            {},
            document.title,
            url.pathname + url.search,
          );
          // removing clavedone field
          if (isEditMode) {
            formHandler.next();
          } else {
            const role = localStorage.getItem("usertype");
            await updateUserProfile({ step: isGuarantor ? 4 : 3, role });
            if (window.location.pathname === "/onboarding" && !isGuarantor) {
              trackClarityEvent("tenant_document_upload_step_ended");
              setTimeout(() => {
                trackClarityEvent("tenant_missing_document_step_started");
              }, constants.CLARITY_DELAY);
            }
          }
        }
      } else {
        const role = localStorage.getItem("usertype");
        const url = new URL(window.location);
        detectDocument(user?._id);
        // removing clavedone field
        url.searchParams.delete("claveDone");
        window.history.replaceState(
          {},
          document.title,
          url.pathname + url.search,
        );
        // removing clavedone field
        if (isEditMode) {
          formHandler.next();
        } else {
          await updateUserProfile({ step: isGuarantor ? 4 : 3, role });
          if (window.location.pathname === "/onboarding" && !isGuarantor) {
            trackClarityEvent("tenant_document_upload_step_ended");
            setTimeout(() => {
              trackClarityEvent("tenant_missing_document_step_started");
            }, constants.CLARITY_DELAY);
          }
        }
      }
    } catch (err) {
      console.error("Error uploading multiple files:", err);
      if (reqFor === "updateDoc") {
        setDocAnalysisLoading(false);
      } else {
        setDocUploadLoading(false);
      }
    }
  };

  const processFiles = async (newFiles) => {
    if (!Array.isArray(newFiles)) return;

    const validFiles = await validateFiles(newFiles);
    if (validFiles.length === 0) return;

    // Total size check (existing + new)
    const existingSize = selectedFiles.reduce((sum, f) => sum + f.size, 0);
    const newSize = validFiles.reduce((sum, f) => sum + f.size, 0);
    const totalSize = existingSize + newSize;

    if (totalSize > 20 * 1024 * 1024) {
      toast.error(_t("totalFileSizeExceeds20MB"));
      return;
    }

    setSelectedFiles((prev) => [...prev, ...validFiles]);
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      processFiles(Array.from(files));
    }
    e.target.value = "";
  };

  const [isDragging, setIsDragging] = useState(false);
  const dragCounter = useRef(0);

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();

    dragCounter.current += 1;
    if (dragCounter.current === 1) {
      setIsDragging(true);
    }
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();

    dragCounter.current -= 1;
    if (dragCounter.current === 0) {
      setIsDragging(false);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current = 0;
    setIsDragging(false);

    const files = e.dataTransfer.files;
    if (!files || files.length === 0) return;

    const newFiles = Array.from(files);
    processFiles(newFiles);
  };

  const fetchFileData = async (custom_tenant_id) => {
    setDocumentLoading(true);
    try {
      const tenant_id = haveValue(custom_tenant_id)
        ? custom_tenant_id
        : user?._id;
      const res = await fetchTenantDocs(tenant_id, false, isGuarantor);

      setTenantDocsData(res?.data?.success_res?.tenantDocs ?? []);
    } catch (error) {
      console.error("Error fetching tenant docs:", error);
    } finally {
      setDocumentLoading(false);
    }
  };

  const getRequiredProtectedHousingDocs = () => {
    const selectedProtectedDocs =
      user?.tenant_extra_field_id?.[constants.public_housing_fileFrom] ?? [];

    const baseProtectedDocs = selectedProtectedDocs.filter(
      (doc) =>
        doc &&
        doc !== constants.no_special_circumstances &&
        doc !== constants.certificate_of_residency_registration,
    );

    const hasNoSpecialCircumstances = selectedProtectedDocs.includes(
      constants.no_special_circumstances,
    );

    if (baseProtectedDocs.length > 0) {
      return [
        ...baseProtectedDocs,
        constants.certificate_of_residency_registration,
      ];
    }

    if (hasNoSpecialCircumstances) {
      return [constants.certificate_of_residency_registration];
    }

    return [];
  };

  const [otherDocs, setOtherDocs] = useState([]);
  const [payslipDocs, setPayslipDocs] = useState([]);
  const [docFound, setDocFound] = useState(new Map());
  const [haveClavePinDoc, setHaveClavePinDoc] = useState(false);

  useEffect(() => {
    if (haveValue(tenantDocsData) && tenantDocsData.length >= 1) {
      const temp_map = new Map();
      const type_map = new Map();
      const other_type = new Map();
      let payslips = [];

      tenantDocsData.map((docs) => {
        if (docs?.type?.toLowerCase()?.includes("payslip")) {
          payslips.push(docs);
          return;
        }
        if (docs?.from == "clave") {
          temp_map.set(docs?.type);
          setHaveClavePinDoc(true);
        }
        if (
          !type_map.has(docs?.type + (docs?.year ? docs?.year : "")) &&
          docs?.from != constants.others
        ) {
          type_map.set(docs?.type + (docs?.year ? docs?.year : ""), docs);
        }
        if (docs?.from == "others" && !other_type?.has(docs?.type)) {
          other_type.set(docs?.type, docs);
        }
      });

      payslips = payslips.sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at),
      );
      setPayslipDocs(payslips);
      setDocFound(type_map);
      setOtherDocs([...other_type.values()]);
    }
  }, [tenantDocsData]);

  const [documentList, setDocumentList] = useState([]);
  const [selectedDocData, setSelectedDocData] = useState({});
  const [additionalDocs, setAdditionalDocs] = useState([]);

  useEffect(() => {
    const notInDocumentList = Array.from(docFound.entries())
      .filter(([key]) => !documentList.includes(key))
      .map(([_, value]) => value);
    setAdditionalDocs(notInDocumentList);
  }, [docFound, documentList]);

  useEffect(() => {
    if (!user) return;

    let allDocs = getDocumentsFromEmploymentType(user, true);
    setSelectedDocData(allDocs);

    let allDocsWithoutProtectedHousing = getDocumentsFromEmploymentType(user);
    let baseDocs = Object.keys(allDocsWithoutProtectedHousing);
    const finalProtectedDocs = getRequiredProtectedHousingDocs();

    const mergedDocs = [...new Set([...baseDocs, ...finalProtectedDocs])];

    setDocumentList(mergedDocs);
  }, [user]);

  // ********** clave functionality **********
  const handleInitiateClave = async (e) => {
    setWaitingJobId(null);

    let temp_clave_models = {
      AEAT_100_RENTA: false,
      AEAT_130_IRPF_DIRECTA: false,
      AEAT_303_IVA_AUTOLIQUIDACION: false,
      SEG_SOCIAL_VIDA_LABORAL: false,
      SEG_SOCIAL_CERT_INTEGRAL_PRESTACIONES: false,
      SEG_SOCIAL_BASE_COTIZACIONES: false,
    };

    if (user?.employment_status == constants.employed) {
      temp_clave_models = {
        ...temp_clave_models,
        SEG_SOCIAL_BASE_COTIZACIONES: true,
      };
    }
    if (
      user?.employment_status == constants.employed ||
      user?.employment_status == constants.unemployed ||
      user?.employment_status == constants.public_servant
    ) {
      temp_clave_models = {
        ...temp_clave_models,
        SEG_SOCIAL_VIDA_LABORAL: true,
        AEAT_100_RENTA: true,
      };
    }
    if (user?.employment_status == constants.self_employed) {
      temp_clave_models = {
        ...temp_clave_models,
        SEG_SOCIAL_VIDA_LABORAL: true,
        AEAT_100_RENTA: true,
        AEAT_130_IRPF_DIRECTA: true,
        SEG_SOCIAL_BASE_COTIZACIONES: true,
      };
    }
    if (
      user?.employment_status == constants.self_employed &&
      user?.employment_category == "freelancer"
    ) {
      temp_clave_models = {
        ...temp_clave_models,
        AEAT_303_IVA_AUTOLIQUIDACION: true,
        SEG_SOCIAL_BASE_COTIZACIONES: true,
      };
    }

    if (
      user?.employment_status == constants.retired ||
      user?.employment_status == constants.unemployed
    ) {
      temp_clave_models = {
        ...temp_clave_models,
        SEG_SOCIAL_CERT_INTEGRAL_PRESTACIONES: true,
      };
    }

    initiateBankFlip(
      temp_clave_models,
      false,
      user?._id,
      reqFor === "updateDoc"
        ? redirectUrl
        : isGuarantor
          ? `guarantor/onboarding?guarantor_a_id=${guarantor_a_id}&claveDone=true`
          : "onboarding?claveDone=true&waiting=",
      needWaitingJobForClave,
    )
      .then((res) => {
        setClaveWidgetUrl(res.success_res.widgetLink);
        setWaitingJobId(res.success_res.waiting_id);
      })
      .catch((err) => {
        toast.error(_t("errorWhileInitiatingTheSignatureProcess"));
        trackClarityEvent("tenant_bankflip_error");
      });
  };

  const handleClose = () => {
    setClaveWidgetUrl(null);
  };

  const handleSuccess = (data) => {
    startWaitingJobInterval(waitingJobId);
    toast.success(_t("bankflipSuccess"));
  };

  const handleError = (data) => {
    toast.success(
      _t("bankflipFailure", "When bankflip give any failure response/message"),
    );
  };
  // ********** clave functionality **********

  const handleInitiateUpload = () => {
    const claveDocs = [];
    documentList.map((docItem, index) => {
      if (docsData.CLAVE_DOCS.includes(selectedDocData?.[docItem])) {
        claveDocs.push(selectedDocData?.[docItem]);
      }
    });
    if (
      claveDocs.length > 0 &&
      user?.clave_done != true &&
      isFirstTime &&
      !isGuarantor
    ) {
      setShowApprovalPopup(true);
      setAvailableClaveDocs(claveDocs);
    } else {
      handleUploadFiles();
    }
  };

  const onhandleManualUpload = () => {
    setShowApprovalPopup(false);
    const url = new URL(window.location.href);
    url.search = ""; // ⛔️ Clear all query parameters
    window.history.pushState({}, "", url.toString());
    handleUploadFiles();
  };

  function removeWelcomeParam() {
    const url = new URL(window.location.href);

    if (url.searchParams.has("welcome")) {
      setShowWelcomePopup(false);
      url.searchParams.delete("welcome");
      window.history.replaceState(
        {},
        document.title,
        url.pathname + url.search,
      );
    }
  }

  const removeValidFile = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const removeInvalidFile = (index) => {
    setInvalidFiles((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <>
      <DisableZoom />
      <div
        className={`popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen ${
          isGuarantor ? "guarantorBg" : ""
        }`}
      >
        <div
          className="popup-content2 required-doc-popup position-relative popup-content bg-white"
          onClick={
            isGuarantor
              ? (e) => {
                  e.stopPropagation();
                  removeWelcomeParam();
                }
              : () => removeWelcomeParam()
          }
        >
          <div className="row">
            <div className="col-12">
              <div className="d-flex align-items-center justify-content-between infoWrapper">
                <h4>
                  {_t("requiredDocuments", "Text used in onboarding flow")}
                  <span className="hideOnMobile">
                    (
                    {_t(
                      "uploadMoreOrOtherIfYouDontHaveAll",
                      "Text used in onboarding flow",
                    )}
                    )
                  </span>
                </h4>
                <ul className="infodorpdown summarydropdum showOnMobile position-relative">
                  <li>
                    <img
                      src={moreInfoimg}
                      alt="Vector Icon"
                      className="vactorImg vactorImg1"
                    />
                  </li>
                  <ul className="tooltip mobile-right-tooltip">
                    <h4>
                      {_t(
                        "documentsComingBasedOn",
                        "Shown on mobile view where documents are asked on onboarding flow as a tooltip",
                      )}
                    </h4>
                    <li>
                      {_t("employmentStatus")}{" "}
                      <span>{_t(user?.employment_status)}</span>
                    </li>
                    {(requiresSubcategory(user?.employment_status) ?? "") && (
                      <li>
                        {_t("employmentCategory")}{" "}
                        <span>{_t(user?.employment_category)}</span>
                      </li>
                    )}
                    <li>
                      {_t(
                        "appliedForProtectedHousing",
                        "Text used in onboarding process",
                      )}{" "}
                      <span>
                        {user?.protected_housing ? _t("yes") : _t("no")}
                      </span>
                    </li>
                  </ul>
                </ul>
              </div>
              {(isGuarantor || isEditMode) && (
                <div
                  className="cursor-pointer"
                  onClick={() => navigate("/home")}
                >
                  <img
                    src={Cancelimg}
                    alt="icon"
                    className="canceicon topRightIcon"
                  />
                </div>
              )}
              <div className="list-requerment-div d-flex gap-4 align-items-center justify-content-between">
                <ul className="list-requerment d-flex gap-6 align-items-center hideOnMobile">
                  <li>
                    {_t("employmentStatus")}{" "}
                    <span>{_t(user?.employment_status)}</span>
                  </li>
                  {(requiresSubcategory(user?.employment_status) ?? "") && (
                    <li>
                      {_t("employmentCategory")}{" "}
                      <span>{_t(user?.employment_category)}</span>
                    </li>
                  )}
                  <li>
                    {_t(
                      "appliedForProtectedHousing",
                      "Text used in onboarding process",
                    )}{" "}
                    <span>
                      {user?.protected_housing ? _t("yes") : _t("no")}
                    </span>
                  </li>
                </ul>
                <div>
                  <p className="hideOnMobile">
                    {docFound.size + otherDocs.length + payslipDocs.length}/
                    {documentList.length +
                      otherDocs.length +
                      payslipDocs.length}{" "}
                    {_t("docsUploaded", "Text used in onboarding process")}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row gx-8 required-doc-popup-inner">
            <div className="col-12 col-md-5">
              <div className="hideOnDesktop docCountWrapper">
                <h4 className="documentTextMobile">
                  {_t("documents", "Text used in onboarding flow")}
                  <span>
                    (
                    {_t(
                      "uploadMoreOrOtherIfYouDontHaveAll",
                      "Text used in onboarding flow",
                    )}
                    )
                  </span>
                </h4>
                <p>
                  {docFound.size + otherDocs.length}/
                  {documentList.length + otherDocs.length}{" "}
                </p>
              </div>
              <div className="doc-listing listover overflow-auto">
                {documentLoading || waitingJobLoading ? (
                  <div className="defaultSkorLoaderParent">
                    <img
                      src={SkorDefaultLoader}
                      className="defaultSkorLoader"
                      alt="Example"
                    />
                  </div>
                ) : (
                  <>
                    <div className="docContainerWrapper">
                      {documentList.map((docItem, index) => (
                        <DocItem
                          key={index}
                          docFound={docFound}
                          selectedDocData={selectedDocData}
                          docsData={docsData}
                          docName={selectedDocData?.[docItem]}
                          docItem={
                            docFound.has(docItem)
                              ? docFound.get(docItem)
                              : (() => {
                                  const match = Object.entries(docsMap).find(
                                    ([key, val]) =>
                                      val === docItem && docFound.has(key),
                                  );
                                  return match
                                    ? docFound.get(match[0])
                                    : // #NOTE: if not found in the docFound Map, then also check in payslipDocs. otherwise, return null
                                      payslipDocs.find(
                                          (doc) => doc.type === docItem,
                                        )
                                      ? docItem
                                      : null;
                                })()
                          }
                          handleInitiateClave={handleInitiateClave}
                          index={index}
                          haveClavePinDoc={haveClavePinDoc}
                          showWelcomePopup={showWelcomePopup}
                        />
                      ))}
                      {payslipDocs.map((docItem, index) => (
                        <DocItem
                          key={index}
                          docFound={docFound}
                          docItem={docItem}
                          selectedDocData={selectedDocData}
                          docsData={docsData}
                          docName={docItem?.type}
                          translationFromFixed={true}
                          index={index}
                          haveClavePinDoc={haveClavePinDoc}
                        />
                      ))}
                      {additionalDocs.map((docItem, index) => (
                        <DocItem
                          key={index}
                          docFound={docFound}
                          docItem={docItem}
                          selectedDocData={selectedDocData}
                          docsData={docsData}
                          docName={docItem?.type}
                          translationFromFixed={true}
                          index={index}
                          haveClavePinDoc={haveClavePinDoc}
                        />
                      ))}
                      {otherDocs.map((docItem, index) => (
                        <DocItem
                          key={index}
                          docFound={docFound}
                          docItem={docItem}
                          selectedDocData={selectedDocData}
                          docsData={docsData}
                          docName={docItem?.type}
                          translationFromFixed={true}
                          index={index}
                          haveClavePinDoc={haveClavePinDoc}
                        />
                      ))}
                    </div>
                    <p className="instructionText">
                      {_t(
                        "dontKnowHowToFindTheseDocumentsFollowInstructionsFor",
                      )}
                      <a
                        href="/pdf/Docs_Spanish_Citizens.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {_t("spanishCitizen")}
                      </a>
                      {_t("orFor")}
                      <a
                        href="/pdf/Docs_Required_Non_Spanish_Citizens.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {_t("nonSpanishCitizen")}
                      </a>
                    </p>
                  </>
                )}
              </div>
            </div>
            <div className="col-12 col-md-7 d-flex flex-column">
              <div className="docUploaderMobile">
                {user?.employment_status !== "student" && (
                  <>
                    <div className="doc-listing d-flex align-items-center justify-content-center text-center">
                      <div className="docUpload docUpload2">
                        <button
                          type="button"
                          className={`btnNext  ${
                            haveClavePinDoc ? "selectFilehere" : "btnClave"
                          } `}
                          style={{ cursor: "pointer" }}
                          onClick={handleInitiateClave}
                        >
                          {_t("use")} Cl@ve
                        </button>
                        <p className="custom-pt-2 fw-medium">
                          {_t(
                            "instantDocumentUploadFromYourDigitalId",
                            "Text used in onboarding process",
                          )}
                        </p>
                        <p className="custom-pt-1 keepYourDniNie">
                          {_t(
                            "keepYourDniNieHandyAndTrustedDeviceHandy",
                            "Text used in onboarding process",
                          )}
                        </p>
                        {isMobile && (
                          <p className="claveText">
                            {_t("getFastTrackedLandlordsPreferToReceive")}
                            {_t("documentsVia")} Cl<span>@</span>ve Pin
                          </p>
                        )}
                      </div>
                    </div>
                    <p className="spacepx">{_t("or")}</p>
                  </>
                )}

                {docUploadLoading ? (
                  <div
                    className="doc-listing doc-listing2 d-flex align-items-center justify-content-center text-center"
                    style={{ height: 244 }}
                  >
                    <div className="defaultSkorLoaderParent">
                      <img
                        src={SkorDefaultLoader}
                        className="defaultSkorLoader"
                        alt="Example"
                      />
                    </div>
                  </div>
                ) : (
                  <div
                    className="doc-listing doc-listing2 doc-listing3 h-100 d-flex align-items-center justify-content-center text-center cursor-pointer"
                    onClick={
                      selectedFiles.length === 0 && invalidFiles.length === 0
                        ? handleClick
                        : undefined
                    }
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onDragEnter={handleDragEnter}
                    onDragLeave={handleDragLeave}
                    style={{
                      backgroundColor: isDragging ? "#A3EB64" : "transparent",
                      transition: "background-color 0.2s ease",
                    }}
                  >
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                      accept="application/pdf, image/jpeg, image/png, image/jpg"
                      multiple
                    />
                    {selectedFiles.length > 0 || invalidFiles.length > 0 ? (
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          justifyContent: "space-between",
                          flexDirection: "column",
                        }}
                        className="uploaded-list-wrapper"
                      >
                        <div className="uploaded-list">
                          {invalidFiles.map((file, index) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  backgroundColor: "#fdf5f5",
                                  borderColor: "#f19492",
                                }}
                                className="d-flex uploaded-files-view align-items-center justify-content-between flex-wrap"
                              >
                                <div className="uploaded-files-view-name">
                                  <img src="/images/docIconGreen.svg" alt="" />
                                  <div className="upload-file-name">
                                    <h1
                                      className="mb-0 text-truncate"
                                      style={{ maxWidth: "250px" }}
                                    >
                                      {file.name}
                                    </h1>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between ">
                                  <div
                                    style={{ color: "#dc2828" }}
                                    className="corrupted-upload-files"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-circle-alert w-5 h-5 text-destructive"
                                    >
                                      <circle cx="12" cy="12" r="10"></circle>
                                      <line
                                        x1="12"
                                        x2="12"
                                        y1="8"
                                        y2="12"
                                      ></line>
                                      <line
                                        x1="12"
                                        x2="12.01"
                                        y1="16"
                                        y2="16"
                                      ></line>
                                    </svg>
                                    <span>{file.reason}</span>
                                  </div>

                                  <div
                                    className="cursor-pointer uploaded-files-view-delete-icon"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      removeInvalidFile(index);
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-trash2 w-4 h-4"
                                    >
                                      <path d="M3 6h18"></path>
                                      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                                      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                                      <line
                                        x1="10"
                                        x2="10"
                                        y1="11"
                                        y2="17"
                                      ></line>
                                      <line
                                        x1="14"
                                        x2="14"
                                        y1="11"
                                        y2="17"
                                      ></line>
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                          {selectedFiles.map((file, index) => {
                            const sizeInKB = file.size / 1024;
                            const sizeText =
                              sizeInKB < 1024
                                ? `${sizeInKB.toFixed(1)} KB`
                                : `${(sizeInKB / 1024).toFixed(2)} MB`;

                            return (
                              <div
                                key={index}
                                className="d-flex uploaded-files-view align-items-center justify-content-between file-item flex-wrap"
                              >
                                <div className="uploaded-files-view-name">
                                  <img src="/images/docIconGreen.svg" alt="" />
                                  <div className="upload-file-name">
                                    <h1
                                      className="text-truncate"
                                      style={{ maxWidth: "250px" }}
                                    >
                                      {file.name}
                                    </h1>
                                    <span>{sizeText}</span>
                                  </div>
                                </div>

                                <div
                                  className="cursor-pointer uploaded-files-view-delete-icon"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removeValidFile(index);
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-trash2 w-4 h-4"
                                  >
                                    <path d="M3 6h18"></path>
                                    <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path>
                                    <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path>
                                    <line
                                      x1="10"
                                      x2="10"
                                      y1="11"
                                      y2="17"
                                    ></line>
                                    <line
                                      x1="14"
                                      x2="14"
                                      y1="11"
                                      y2="17"
                                    ></line>
                                  </svg>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                        <div className="text-center mt-2">
                          <button
                            type="button"
                            onClick={() => fileInputRef.current.click()}
                            className="btnNext btnSelectFile selectFilehere"
                          >
                            {_t("addMoreFiles", "Add more files")}
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div className="docUpload">
                          <div className="Uploadimgdiv">
                            <img src={Uploadimg} alt="upload-img" />
                          </div>
                          <p className="drag-drop-content pt-3">
                            {_t(
                              "dragAndDropYourDocumentsHere",
                              "Text used in onboarding process",
                            )}
                          </p>
                          <p className="spacepx">{_t("or")}</p>
                          <button
                            type="button"
                            className={`btnNext btnSelectFile ${
                              !haveClavePinDoc ? "selectFilehere" : "btnClave"
                            } `}
                          >
                            {_t(
                              "selectFromFiles",
                              "Text used in onboarding process",
                            )}
                          </button>
                          <p className="fileSizeText">
                            {_t(
                              "ensureTheSizeOfFileMustBeLessThan2MbOr20MbForBulkFileUpload",
                            )}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-center gap-3 custom-mt-3">
            {(!isGuarantor || reqFor === "updateDoc") && (
              <button
                type="button"
                className="btnNext btnnextpre"
                onClick={
                  reqFor === "updateDoc"
                    ? onClose
                    : () => {
                        formHandler.prev();
                        trackClarityEvent("tenant_retry_basic_info");
                      }
                }
              >
                {reqFor === "updateDoc" ? _t("close") : _t("back")}
              </button>
            )}
            <div
              data-tooltip-id="button-action-tooltip"
              style={{ display: "inline-block" }}
            >
              <button
                type="button"
                onClick={() => handleInitiateUpload()}
                className="btnNext greenHover"
                disabled={
                  docUploadLoading ||
                  (docFound.size === 0 && selectedFiles.length === 0) ||
                  invalidFiles.length > 0
                }
              >
                {reqFor === "updateDoc" ? _t("submit") : _t("next")}
              </button>
              {docUploadLoading ||
                (docFound.size === 0 && selectedFiles.length === 0) ||
                (invalidFiles.length > 0 && <ButtonActionTooltip />)}
            </div>
          </div>
        </div>
        <ApprovedModal
          showPopup={showApprovalPopup}
          setShowApprovalPopup={setShowApprovalPopup}
          availableClaveDocs={availableClaveDocs}
          onhandleManualUpload={onhandleManualUpload}
          handleInitiateClave={handleInitiateClave}
        />
        <DocumentAnalysisLoadingPopup
          isGuarantor={isGuarantor}
          showPopup={docUploadLoading}
        />

        {claveWidgetUrl && (
          <PermissoWidget
            widgetUrl={claveWidgetUrl}
            onClose={handleClose}
            onSuccess={handleSuccess}
            onError={handleError}
          />
        )}
      </div>
    </>
  );
};

export default RequiredDocumentsModal;
